import { createSlice } from "@reduxjs/toolkit";
import {
  addOrUpdateRatingThunk,
  fetchRatingsByMerchantThunk,
  fetchUserRatingsThunk,
} from "./ratingThunks";

const initialState = {
  submitting: false,
  loadingMerchantRatings: false,
  loadingUserRatings: false,

  merchantRatings: [],
  averageRating: 0,

  userRatings: [],

  successMessage: null,
  error: null,
};

const ratingSlice = createSlice({
  name: "rating",
  initialState,
  reducers: {
    clearRatingMessage: (state) => {
      state.successMessage = null;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // =========================
      // ADD / UPDATE RATING
      // =========================
      .addCase(addOrUpdateRatingThunk.pending, (state) => {
        state.submitting = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(addOrUpdateRatingThunk.fulfilled, (state, action) => {
        state.submitting = false;
        state.successMessage = action.payload.message;
      })
      .addCase(addOrUpdateRatingThunk.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      })

      // =========================
      // FETCH MERCHANT RATINGS
      // =========================
      .addCase(fetchRatingsByMerchantThunk.pending, (state) => {
        state.loadingMerchantRatings = true;
        state.error = null;
      })
      .addCase(fetchRatingsByMerchantThunk.fulfilled, (state, action) => {
        state.loadingMerchantRatings = false;
        state.merchantRatings = action.payload.ratings || [];
        state.averageRating = action.payload.averageRating || 0;
      })
      .addCase(fetchRatingsByMerchantThunk.rejected, (state, action) => {
        state.loadingMerchantRatings = false;
        state.error = action.payload;
      })

      // =========================
      // FETCH USER RATINGS
      // =========================
      .addCase(fetchUserRatingsThunk.pending, (state) => {
        state.loadingUserRatings = true;
        state.error = null;
      })
      .addCase(fetchUserRatingsThunk.fulfilled, (state, action) => {
        state.loadingUserRatings = false;
        state.userRatings = action.payload.ratings || [];
      })
      .addCase(fetchUserRatingsThunk.rejected, (state, action) => {
        state.loadingUserRatings = false;
        state.error = action.payload;
      });
  },
});

export const { clearRatingMessage } = ratingSlice.actions;
export default ratingSlice.reducer;
